export const FETCH_AUTH_TOKEN = 'FETCH_AUTH_TOKEN';
export const FETCH_DATA = 'FETCH_DATA';
export const FETCH_PACKAGE_URL = 'FETCH_PACKAGE_URL';
export const RESET_SERVER_ERROR = 'RESET_SERVER_ERROR';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_CURRENT_MANAGER = 'SET_CURRENT_MANAGER';
export const SET_CRM_STATUS = 'SET_CRM_STATUS';
export const SET_CRM_STATUS_SUCCESS = 'SET_CRM_STATUS_SUCCESS';
export const CHANGE_CRM_MANUAL_STATE = 'CHANGE_CRM_MANUAL_STATE';
export const CRM_REQUEST_GENERAL_STATE = 'CRM_REQUEST_GENERAL_STATE';
export const CRM_SYNC_GENERAL_STATE = 'CRM_SYNC_GENERAL_STATE';

export const SET_SERVER_ERROR = 'SET_SERVER_ERROR';
export const SET_TIME = 'SET_TIME';
export const WS_UPDATE_CRM_STATUS = 'WS_UPDATE_CRM_STATUS';
export const SET_WS_CURRENT_MANAGER_TICKETS_COUNT =
  'SET_WS_CURRENT_MANAGER_TICKETS_COUNT';
export const SET_WS_ONLINE_STATUS = 'SET_WS_ONLINE_STATUS';
export const RESET_ERRORS = 'RESET_ERRORS';
export const RESET_CRITICAL_ERRORS = 'RESET_CRITICAL_ERRORS';
export const SET_ASSETS_VERSION = 'SET_ASSETS_VERSION';
export const SET_HAS_ASSET_UPDATES = 'SET_HAS_ASSET_UPDATES';
export const SET_MANAGER_STATUSES = 'SET_MANAGER_STATUSES';
export const REFETCH_MANAGER_STATUSES = 'REFETCH_MANAGER_STATUSES';

export const SENTRY_ENABLED = 'SENTRY_ENABLED';

export const SET_LEADER_INSTANCE = 'SET_LEADER_INSTANCE';
export const UNSET_LEADER_INSTANCE = 'UNSET_LEADER_INSTANCE';
export const LEADER_INSTANCE_CHANNEL = 'LEADER_INSTANCE_CHANNEL';

export const AUTH_TOKEN_ROTTEN = 'AUTH_TOKEN_ROTTEN';
export const AUTH_REDIRECT_TO_LOG_IN = 'AUTH_REDIRECT_TO_LOG_IN';

export const TOGGLE_BUGS_DROPDOWN = 'TOGGLE_BUGS_DROPDOWN';

export const SUBMIT_CUSTOM_REPORT = 'SUBMIT_CUSTOM_REPORT';

export const SET_TAB_ACTIVE = 'SET_TAB_ACTIVE';
export const SET_NOTIFICATIONS_COUNT = 'SET_NOTIFICATIONS_COUNT';
export const RESET_NOTIFICATIONS_COUNT = 'RESET_NOTIFICATIONS_COUNT';
export const SET_IS_NOTIFICATIONS_SOUND_ENABLED =
  'SET_IS_NOTIFICATIONS_SOUND_ENABLED';

export const SWITCH_THEME = 'SWITCH_THEME';

export const SET_VOLUME = 'SET_VOLUME';

export const setVolume = payload => ({ payload, type: SET_VOLUME });

export const switchTheme = payload => ({ payload, type: SWITCH_THEME });

export const fetchPackageUrl = payload => ({
  payload,
  type: FETCH_PACKAGE_URL,
});

export const resetGeneralErrors = () => ({ type: RESET_ERRORS });

export const resetCriticalErrors = () => ({ type: RESET_CRITICAL_ERRORS });

export const resetServerErrors = () => ({ type: RESET_SERVER_ERROR });

export const toggleBugsDropdown = isOpen => ({
  isOpen,
  type: TOGGLE_BUGS_DROPDOWN,
});

export const submitCustomReport = data => ({
  text: data.reportInput,
  category: data.categorySelector.value,
  type: SUBMIT_CUSTOM_REPORT,
});

export const changeManualStatus = ({ state, isManual }) => ({
  payload: {
    isManual,
    state,
  },
  type: CHANGE_CRM_MANUAL_STATE,
});

export const setTabActive = isTabActive => ({
  payload: { isTabActive },
  type: SET_TAB_ACTIVE,
});

export const setNotificationsCount = notificationsCount => ({
  payload: { notificationsCount },
  type: SET_NOTIFICATIONS_COUNT,
});

export const resetNotificationsCount = () => ({
  type: RESET_NOTIFICATIONS_COUNT,
});

export const setIsNotificationsSoundEnabled = isNotificationsSoundEnabled => ({
  payload: { isNotificationsSoundEnabled },
  type: SET_IS_NOTIFICATIONS_SOUND_ENABLED,
});
